import { Coins, Gift, Layers, ListChecks, Users } from "lucide-react";
import type { SideTab } from "@/components/shared";
import { IncomeEntriesReport } from "@/components/reports";
import { useAdminIncomeEntries } from "@/hooks/queries";

/**
 * Report registry. To add a report, append an entry here: it gets its own tab in the
 * left navigation and its own URL (/admin/reports/<id>). Entries sharing a `group`
 * are listed under the same heading.
 */
export type ReportDef = SideTab;

export const reports: ReportDef[] = [
  {
    id: "all",
    label: "All Summary",
    group: "Income",
    icon: ListChecks,
    render: () => (
      <IncomeEntriesReport
        useEntries={useAdminIncomeEntries}
        showEarner
        kind="all"
        title="All Summary"
        description="All cashback and referral income transactions combined."
      />
    ),
  },
  {
    id: "direct",
    label: "Direct Income",
    group: "Income",
    icon: Users,
    render: () => (
      <IncomeEntriesReport
        useEntries={useAdminIncomeEntries}
        showEarner
        kind="direct"
        title="Direct Income"
        description="Referral commissions earned from Level 1 direct team members."
      />
    ),
  },
  {
    id: "level",
    label: "Level Income",
    group: "Income",
    icon: Layers,
    render: () => (
      <IncomeEntriesReport
        useEntries={useAdminIncomeEntries}
        showEarner
        kind="level"
        title="Level Income"
        description="Multi-level referral cashback distributed to uplines."
      />
    ),
  },
  {
    id: "reward",
    label: "Reward Income",
    group: "Income",
    icon: Gift,
    render: () => (
      <IncomeEntriesReport
        useEntries={useAdminIncomeEntries}
        showEarner
        kind="reward"
        title="Reward Income"
        description="Income generated from claiming Rank Reward milestones."
      />
    ),
  },
  {
    id: "cashback",
    label: "Cashback Income",
    group: "Income",
    icon: Coins,
    render: () => (
      <IncomeEntriesReport
        useEntries={useAdminIncomeEntries}
        showEarner
        kind="cashback"
        title="Cashback Income"
        description="Cashback earned from self purchases and active member bonuses."
      />
    ),
  },
];
